const AppConfig = {
    site: {
        logoSrc: `${process.env.PUBLIC_URL}/logo.png`,
    },
};

export default AppConfig;
